class infinityButton extends HTMLElement {
  constructor() {
    super();
    this.link = this.querySelector('.btn');
    this.link&&this.link.addEventListener('click', this.handler.bind(this));
    /* 2026-07-29: scroll handler eskiden HER scroll olayinda (saniyede yuzlerce kez)
       calisiyor ve her seferinde offsetTop okuyup zorunlu reflow tetikliyordu.
       requestAnimationFrame kilidi ile kare basina EN FAZLA 1 kez calisir —
       davranis ayni, maliyet ~10 kat dusuk. Buyuk koleksiyonlarda hizli kaydirmada
       fark edilir (bkz. footer.liquid park mekanizmasi). */
    if (this.classList.contains('autoscroll_yes')) {
      var _this = this;
      this._rafPending = false;
      this._onScroll = function () {
        if (_this._rafPending) return;
        _this._rafPending = true;
        window.requestAnimationFrame(function () {
          _this._rafPending = false;
          _this.autoscrollhandler();
        });
      };
      window.addEventListener('scroll', this._onScroll, { passive: true });
    }
  }
  handler(event){
    event.preventDefault();
    if(this.destroyed) return false;
    placeCollectionLoader();
    document.querySelector('.collection_facets_loader').classList.add('loading_now');
    var url = event.currentTarget.href;
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        var container = false,
            _html = false;
        
        container = document.querySelector('.collection__container').lastElementChild;
        _html = new DOMParser().parseFromString(html, 'text/html').querySelector('.collection__container').innerHTML;
        container.insertAdjacentHTML("afterend", _html);

        container = document.querySelector('infinity-button');
        _html = new DOMParser().parseFromString(html, 'text/html').querySelector('infinity-button');
        container.replaceWith(_html);

        document.querySelector('.collection_facets_loader').classList.remove('loading_now');
    });
  }
  autoscrollhandler(){
    if(!this.link || this.destroyed) return false;
    if(!this.link.classList.contains('autoscroll')) return false;
    var contY = parseInt(this.link.parentNode.offsetTop);
    var wY = this.getWindowHeight()+this.getWindowTopY();
    if( contY <= wY ) {
      this.link.classList.remove('autoscroll');
      this.link.dispatchEvent(new Event('click', {bubbles: true, cancelable: true}));
    }
  }
  getWindowHeight(){
    return window.innerHeight;
  }
  getWindowTopY(){
    return window.pageYOffset || document.documentElement.scrollTop;
  }
  disconnectedCallback(){
    this.destroyed = true;
    /* 2026-07-29 SIZINTI DUZELTMESI: her sayfa yuklemesinde handler() bu elemani
       replaceWith() ile YENISIYLE degistiriyor ve yeni eleman window'a YENI bir
       scroll dinleyicisi ekliyordu. Eskisi hic kaldirilmadigi icin 48 sayfalik bir
       koleksiyonda window'da 48 dinleyici birikiyordu (hepsi destroyed kontrolunde
       erken donse de her scroll'da cagriliyorlardi). Artik eleman DOM'dan cikinca
       kendi dinleyicisini de goturuyor. */
    if (this._onScroll) {
      window.removeEventListener('scroll', this._onScroll);
      this._onScroll = null;
    }
    this.remove();
  }
}
customElements.define('infinity-button', infinityButton);